import { render, staticRenderFns } from "./RunningText.vue?vue&type=template&id=08abb9fe&scoped=true&"
import script from "./RunningText.vue?vue&type=script&lang=js&"
export * from "./RunningText.vue?vue&type=script&lang=js&"
import style0 from "./RunningText.vue?vue&type=style&index=0&id=08abb9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08abb9fe",
  null
  
)

export default component.exports